export default "__VITE_ASSET__D9qfoS91__"